// src/components/utils/PlatformButtonStyles.js
export const getPlatformButtonStyles = (platform) => {
  switch (platform) {
    case 'kick':
      return {
        primaryColor: 'bg-green-600',
        hoverColor: 'hover:bg-green-700',
        glowColor: 'hover:shadow-lg hover:shadow-green-500/50',
        textColor: 'text-green-600',
        TwotextColor: 'text-white',
        tableTextColor: 'text-green-700',
      };
    case 'twitch':
      return {
        primaryColor: 'bg-purple-600',
        hoverColor: 'hover:bg-purple-700',
        glowColor: 'hover:shadow-lg hover:shadow-purple-500/50',
        textColor: 'text-purple-600',
        TwotextColor: 'text-white',
        tableTextColor: 'text-purple-700',
      };
    case 'wtv':
      return {
        primaryColor: 'bg-blue-600',
        hoverColor: 'hover:bg-blue-700',
        glowColor: 'hover:shadow-lg hover:shadow-blue-500/50',
        textColor: 'text-blue-600',
        TwotextColor: 'text-white',
        tableTextColor: 'text-blue-700',
      };
    default:
      return {
        primaryColor: 'bg-gray-600',
        hoverColor: 'hover:bg-gray-700',
        glowColor: 'hover:shadow-lg hover:shadow-gray-500/50',
        textColor: 'text-gray-600',
        TwotextColor: 'text-gray-600',
        tableTextColor: 'text-gray-700',
      };
  }
};
